import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02e4f148"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "card"
}
const _hoisted_2 = { class: "card-body text-center py-15" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-900 fw-bolder mb-3" }, "A Lux está indisponível no momento", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-gray-500 fs-5 mb-0 mx-auto",
  style: {"max-width":"520px"}
}, " Ela foi pausada pela equipe e volta em breve. Suas conversas continuam salvas. ", -1))
const _hoisted_5 = {
  key: 2,
  class: "row g-5"
}
const _hoisted_6 = { class: "col-lg-3" }
const _hoisted_7 = { class: "card h-100" }
const _hoisted_8 = { class: "card-header align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-gray-900" }, "Conversas", -1))
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg fs-6" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Nova ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "card-body p-3 lux-history" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-500 fs-7 px-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "overflow-hidden me-2" }
const _hoisted_18 = { class: "text-gray-900 fw-bold fs-7 text-truncate" }
const _hoisted_19 = { class: "text-gray-500 fs-8" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-7" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "col-lg-9" }
const _hoisted_24 = { class: "card lux-chat" }
const _hoisted_25 = { class: "card-header align-items-center" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-gray-900 mb-0" }, "Lux", -1))
const _hoisted_28 = { class: "text-gray-500 fs-8" }
const _hoisted_29 = {
  ref: "scroller",
  class: "card-body lux-chat__body"
}
const _hoisted_30 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "text-center py-10"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 fs-6 mb-0" }, " Travou numa máquina? Quer um plano de estudo? Manda ver. ", -1))
const _hoisted_35 = {
  key: 2,
  class: "d-flex align-items-center text-gray-500 fs-7 ms-3"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-3" }, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Lux está escrevendo... ")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "card-footer pt-4" }
const _hoisted_40 = {
  key: 0,
  class: "alert alert-danger py-2 px-4 fs-7 mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuxUpsell = _resolveComponent("LuxUpsell")!
  const _component_LuxAvatar = _resolveComponent("LuxAvatar")!
  const _component_LuxMessage = _resolveComponent("LuxMessage")!
  const _component_LuxComposer = _resolveComponent("LuxComposer")!

  return (!_ctx.allowed)
    ? (_openBlock(), _createBlock(_component_LuxUpsell, { key: 0 }))
    : (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_LuxAvatar, {
              size: 120,
              class: "mx-auto mb-6"
            }),
            _hoisted_3,
            _hoisted_4
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-light-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newConversation && _ctx.newConversation(...args)))
                  }, _hoisted_13)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (!_ctx.conversations.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Nenhuma conversa ainda. "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: conversation.uuid,
                    class: _normalizeClass(["lux-history__item d-flex align-items-center justify-content-between p-3 rounded mb-1", { 'lux-history__item--active': conversation.uuid === _ctx.activeUuid }]),
                    onClick: ($event: any) => (_ctx.openConversation(conversation.uuid))
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(conversation.title || "Sem título"), 1),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDate(conversation.last_message_at)), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-icon btn-sm btn-active-light-danger",
                      title: "Apagar",
                      onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(conversation.uuid)), ["stop"])
                    }, _hoisted_22, 8, _hoisted_20)
                  ], 10, _hoisted_16))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_LuxAvatar, {
                    size: 44,
                    thinking: _ctx.isSending,
                    class: "me-3"
                  }, null, 8, ["thinking"]),
                  _createElementVNode("div", null, [
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.isSending ? "pensando..." : "mentora de segurança ofensiva"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                  : (!_ctx.messages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_LuxAvatar, {
                          size: 96,
                          class: "mx-auto mb-5"
                        }),
                        _hoisted_34
                      ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                  return (_openBlock(), _createBlock(_component_LuxMessage, {
                    key: message.id,
                    message: message
                  }, null, 8, ["message"]))
                }), 128)),
                (_ctx.isSending)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
                  : _createCommentVNode("", true)
              ], 512),
              _createElementVNode("div", _hoisted_39, [
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_LuxComposer, {
                  ref: "composer",
                  sending: _ctx.isSending,
                  disabled: _ctx.reachedLimit,
                  remaining: _ctx.remaining,
                  suggestions: _ctx.config?.suggested_prompts ?? [],
                  "show-suggestions": !_ctx.messages.length,
                  onSend: _ctx.onSend
                }, null, 8, ["sending", "disabled", "remaining", "suggestions", "show-suggestions", "onSend"])
              ])
            ])
          ])
        ]))
}